<template>
  <div class="cart">
        <div v-if="this.cartProducts.length == 0 && step != 4" class="container mt-5">
            <section class="bg white mt-sm-5 mt-3">
                <h3 class="ui header large-lg medium-md small black pt-4 pb-4 px-lg-5 px-md-3 px-2 mb-0 text-center">{{$t('MyCart')}}</h3>
                <hr class="gray-7 mt-0">
                <div class="p-lg-5 p-2">
                    <div class="row justify-content-center">
                        <div class="col-lg-2 col-md-3 col-sm-4 col-6">
                            <img src="../assets/img/icon-cart-plus.svg">
                        </div>
                    </div>
                    <p class="ui header semibold medium-lg small-md mini light color gray-7 mt-3 text-center">{{$t('NotCart')}}</p>
                    <div class="row justify-content-center">
                    <router-link to="/" exact class="ui button teal text large"><span class="ui text large"><i class="icon-custom-shop mr-2"></i>{{$t('NowShop')}}</span>
                    </router-link>
                    </div>
                </div>
            </section>
        </div>
        <div v-else class="container mt-5">
            <section class="bg white mt-sm-5 mt-3">
                <h2 class="ui header large-lg medium-md small black pt-4 pb-4 px-lg-5 px-md-3 px-2 mb-0 text-center">{{$t('MyCart')}}</h2>
                <hr class="gray-7 mt-0">
                <h3 v-if="step==1" class="ui header semibold medium-lg small-md mini black pt-3 pb-3 pl-lg-5 px-md-3 px-2 my-0 text-center text-md-left d-inline-block"><span class="ui text big-lg medium-sm small light color gary-7 ml-2"> {{$t('CartAmount',{num: this.cartProducts.length})}}</span></h3>
                <h3 v-if="step==2" class="ui header semibold medium-lg small-md mini black pt-3 pb-3 pl-lg-5 px-md-3 px-2 my-0 text-center text-md-left d-inline-block">
                    {{$t('ShippingServices')}}
                </h3>
                <h3 v-if="step==3" class="ui header semibold medium-lg small-md mini black pt-3 pb-3 pl-lg-5 px-md-3 px-2 my-0 text-center text-md-left d-inline-block">
                    {{$t('OrderList')}}
                </h3>
                <h3 v-if="step==4" class="ui header semibold medium-lg small-md mini black pt-3 pb-3 pl-lg-5 px-md-3 px-2 my-0 text-center text-md-left d-inline-block">
                    {{$t('OrderSuccessful')}}
                </h3>
                <div class="pt-0 px-lg-5 px-md-3 px-2 pb-lg-5 pb-md-3 pb-2">
                    <div class="row">
                        <div v-if="step==1" class="col-lg-8 col-md-7">
                            <div class="cart-list">
                                <div class="border-top">
                                    <div v-for=" (product,i) in cartProducts" :key="'cartOrder' + i" class="item">
                                        <div class="product type-cart border-bottom pt-2 pb-2">
                                            <div class="row">
                                                <div class="col-sm-3 col-4 product__img">
                                                    <div class="thumb">
                                                        <!-- <img :src="[product.image ? $baseURL+ product.image  : 'http://dummy-images.com/abstract/dummy-300x300-FairyLights.jpg']"></div> -->
                                                        <img v-if="product.image" :src="[product.image]">
                                                        <img v-else src="../assets/img/default-noimg.png">
                                                    </div>
                                                </div>
                                                <div class="col-sm-9 col-8">
                                                    <div class="row">
                                                        <div class="d-sm-flex align-items-center mt-sm-2 col-12">
                                                            <div class="py-sm-3 px-3">
                                                                <h5 class="ui text big-lg medium-md small-sm tiny semibold text-truncate mb-lg-3 mb-0">{{product.name}}</h5>
                                                                <p  class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0">{{ (product.netPrice != 0) ? currency + formatPrice(product.netPrice) : currency + formatPrice(product.price) }}  </p>
                                                                <p v-if="product.price != product.netPrice" class="ui text big-lg medium-md tiny-sm small light line-through m-0">{{currency}}{{formatPrice(product.price)}}</p>
                                                                <div v-if="product.sku" class="ui text big-lg medium-md small-sm tiny semibold text-truncate mt-lg-3">
                                                                    <span v-if="product.sku.sku1Name">{{product.sku.sku1Name}} : </span><span class="color red-2 mr-3"> &nbsp; {{product.sku.sku1Select}}</span> 
                                                                    <span v-if="product.sku.sku2Name">{{product.sku.sku2Name}} : </span><span class="color red-2"> &nbsp; {{product.sku.sku2Select}}</span>
                                                                </div>
                                                                <div v-if="product.skus != null && product.sku == null" class="">
                                                                    <select class="ui input text medium-sm small  custom-select" @change="selectSku(product.itemId)" v-model="selectSkuId">
                                                                        <option value="0">select</option>
                                                                        <option v-for="(item, index) in product.skus" :key="index" :value="item">{{skuName(item)}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class="ml-auto text-right d-flex mt-lg-4">
                                                                <div class="input-quantity ui action input">
                                                                    <button  @click="decrement(product)" class="ui icon basic button left p-sm-3 p-2">
                                                                        <i class="minus icon color theme"></i>
                                                                    </button> 
                                                                    <input class="w-40 ui input pb-sm-3 pt-sm-3 p-2" :value="product.amount" readonly> 
                                                                    <button @click="increment(product)" class=" ui icon basic button right p-sm-3 p-2">
                                                                        <i class="plus icon color theme"></i>
                                                                    </button>
                                                                </div>
                                                                <div>
                                                                    <a @click="removeToCart(product)" class="ui button circular basic p-sm-3 p-2 d-inline-block ml-2">
                                                                        <i class="color theme icon trash alternate m-0"></i>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="step==2" class="col-lg-8 col-md-7">
                            <div v-if="shippingServices.length == 0 && loading == false">*{{$t('ChooseShippingAddress')}}</div>
                            <div v-if="shippingServices.length > 0 && loading == false" class="border-top">
                                <div v-for="service in shippingServices" :key="service.courierCode" class="item field pt-4 pb-4 border-bottom">
                                    <div class="row">
                                        <div class="col">
                                            <div class="ui radio checkbox ">
                                                <input :id="'add'+ service.courierCode" type="radio" :value="service.courierCode" v-model="shippingId" > 
                                                <label :for="'add'+ service.courierCode">
                                                    <span class="ui text big-lg medium-sm small semibold black d-block pointer">
                                                        {{service.name}}
                                                    </span>
                                                    <span v-if="service.estimateTime" class="ui text medium-md tiny-sm tiny light d-block mt-2 pointer">
                                                        {{service.estimateTime}}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <span class="col-lg-2 col-3 text-right ui text big-lg medium-sm small semibold color red-2">
                                            {{currency}} {{service.price}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="loading ==true">
                                loading...
                            </div>
                            <h3 class="ui header semibold medium-lg small-md mini black pt-3 pb-3 pl-0  my-0 mt-5 text-center text-md-left d-inline-block">
                                {{$t('ShippingAddress')}}
                            </h3>
                            <div class="border-top">
                                <div v-for="add in address" :key="add.id" class="item field pt-4 pb-4 border-bottom">
                                    <div class="row">
                                        <div class="col">
                                            <div class="ui radio checkbox ">
                                                <input :id="'add'+ add.id" type="radio" :value="add.id" v-model="addressId" > 
                                                <label :for="'add'+ add.id">
                                                    <span class="ui text big-lg medium-sm small semibold black d-block pointer">
                                                        {{add.name}}
                                                    </span>
                                                    <span class="ui text medium-md tiny-sm tiny light d-block mt-2 pointer">
                                                        {{add.text}}
                                                    </span>
                                                    <span class="ui text medium-md tiny-sm tiny light d-block mt-2 pointer">
                                                        เบอร์โทรศัพท์ {{add.phone}}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <!-- <div class="col-lg-2 col-3 text-right">
                                            <a class="ui text big-lg semibold medium-sm p-2 mt-4 color black" href="#">
                                                <i class="icon-custom-edit large"></i>แก้ไข
                                            </a>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="item field pt-4 pb-4">
                                    <div @click="showModalAddress()" class="ui accordion add-address">
                                        <div class="title d-inline-block">
                                            <div  class="ui button circular basic p-2 d-inline-block ml-2">
                                                <i class="color theme icon plus m-0"></i>
                                            </div>
                                            <span class="ui text big-lg medium-sm small semibold black">{{$t('AddAddress')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="step==3" class="col-lg-8 col-md-7">
                            <div class="cart-list mb-5">
                                <div class="border-top">
                                    <div v-for=" (product,i) in cartProducts" :key="'cartOrder' + i" class="item">
                                        <div class="product type-cart border-bottom pt-2 pb-2">
                                            <div class="row">
                                                <div class="col-sm-3 col-4 product__img">
                                                    <div class="thumb">
                                                        <img v-if="product.image" :src="[product.image]">
                                                        <img v-else src="../assets/img/default-noimg.png">
                                                        </div>
                                                </div>
                                                <div class="col-sm-9 col-8">
                                                    <div class="row">
                                                        <div class="d-sm-flex align-items-center mt-sm-2 col-12">
                                                            <div class="py-sm-3 px-3">
                                                                <h5 class="ui text big-lg medium-md small-sm tiny semibold text-truncate mb-lg-3 mb-0">{{product.name}}</h5>
                                                                <p class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0">{{ (product.netPrice != 0) ? currency + formatPrice(product.netPrice) : currency + formatPrice(product.price) }}  </p>
                                                                <p v-if="product.price != product.netPrice" class="ui text big-lg medium-md tiny-sm small light line-through m-0">{{currency}}{{formatPrice(product.price)}}</p>
                                                                <div v-if="product.sku" class="ui text big-lg medium-md small-sm tiny semibold text-truncate mt-lg-3">
                                                                    <span v-if="product.sku.sku1Name">{{product.sku.sku1Name}} : </span><span class="color red-2 mr-3"> &nbsp; {{product.sku.sku1Select}}</span> 
                                                                    <span v-if="product.sku.sku2Name">{{product.sku.sku2Name}} : </span><span class="color red-2"> &nbsp; {{product.sku.sku2Select}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="ml-auto text-right d-flex mt-lg-4">
                                                                <div class="ui text big-lg medium-md tiny-sm small light mr-3">
                                                                    {{product.amount}} ชิ้น
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h3 class="ui header semibold medium-lg small-md mini black pt-3 pb-3 pl-0 my-0 text-center text-md-left d-inline-block">
                                {{$t('Payment')}}
                            </h3>
                            <div class="border-top">
                                <h2 class="ui text big-lg medium-sm small semibold color gray-7 light py-3 mb-0">{{$t('ChoosePaymentMethod')}}</h2>
                                <div class="row justify-content-center">
                                    <div class="col-lg-8 mb-3 custom-tabs ui buttons nav nav-tabs" role="tablist">
                                        <a @click="getPaymentmethod(false)" class="nav-item nav-link active item ui button text huge-lg medium-sm small pt-2 pb-1 px-md-3 px-1" data-toggle="tab" href="#first" role="tab" aria-controls="first-tab" aria-selected="true">{{$t('CreditDebitCard')}}</a> 
                                        <a @click="getPaymentmethod(true)" class="nav-item nav-link item ui button text huge-lg medium-sm small pt-2 pb-1 px-md-3 px-1" data-toggle="tab" href="#second" role="tab" aria-controls="second-tab" aria-selected="false">{{$t('MoneyTransfer')}}</a>
                                    </div>
                                </div>
                                <div class="tab-content" id="nav-tabContent">
                                    <div class="ui tab tab-pane fade" id="second" role="tabpanel" aria-labelledby="second-tab" data-tab="second">
                                        <label class="w-100" for="fileTransefer">
                                            <div class="m-3">
                                                <div class="box-upload d-flex justify-content-center align-items-center">
                                                    <div v-if="urlImg == null" class="col-12 p-0 text-center">
                                                        <div class="title ui text big-lg medium-sm small mb-3 text-light">{{$t('UploadTransferSlip')}}</div>
                                                        <div class="btn btn-lg btn-danger btn-upload">{{$t('Upload')}}</div>
                                                    </div>
                                                    <div v-else class="col-12 p-3 text-center" >
                                                        <div class="row justify-content-center">
                                                            <div class="col-6">
                                                                <img :src="urlImg" class="img-fluid">
                                                            </div>
                                                        </div>
                                                        <div class="btn btn-lg btn-danger btn-upload mt-3">{{$t('Upload')}}</div>
                                                    </div>
                                                    <input @change="onFileChange" id="fileTransefer" ref="fileTransefer" type="file">
                                                </div>
                                            </div>
                                        </label>
                                        <div class="mt-4 text-center">
                                            <button v-if="$parent.logged == true && step == 3" 
                                                :disabled="urlImg == null || loading" 
                                                @click="tranferOrder"
                                                class="ui button teal text pl-4 pr-4">
                                                <span class="ui text large">{{$t('Send')}}</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="ui tab bank-list tab-pane fade show active mb-5" id="first" role="tabpanel" aria-labelledby="first-tab">
                                        <div class="col-12">
                                            <div class="row justify-content-center align-items-center">
                                                <div class="col-3"><img src="../assets/img/img-visa.svg"></div>
                                                <div class="col-3"><img src="../assets/img/img-master-card.svg"></div>
                                                <div class="col-12 text-center">
                                                    <form method="post" action="https://www.thaiepay.com/epaylink/payment.aspx">
                                                        <input type="hidden" name="refno" :value="order.payNo">
                                                        <input type="hidden" name="merchantid" :value="order.merchantId">
                                                        <input v-if="order.email != undefined" type="hidden" name="customeremail" :value="order.email">
                                                        <input type="hidden" name="c" value="00">
                                                        <input type="hidden" name="productdetail" value="Testing Product">
                                                        <input type="hidden" name="total" :value="order.totalPrice">
                                                        <input :disabled="true"  class="ui teal button mt-5 btn-lg pl-4 pr-4" type="submit" name="Submit" value="Pay now">
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="step==4" class="col-lg-8 col-md-7">
                            <hr class="gray-7 mt-0">
                            <div class="text-center pb-2">
                                <h3 class="ui header small-lg tiny-md mini light teal black d-inline-block mt-2 mb-0">
                                    <img class="mt-0 mr-0" src="./../assets/img/icon-check-green-circular.svg">{{$t('OrderSuccessful')}}</h3>
                                <p class="ui text big-md large-sm medium mb-2 0 color theme">{{$t('OrderNo')}} {{order.orderNo}}</p>
                            </div>
                            <div class="cart-list mb-5">
                                <div class="border-top">
                                    <div v-for=" (product,i) in productComplete" :key="'cartOrder' + i" class="item">
                                        <div class="product type-cart border-bottom pt-2 pb-2">
                                            <div class="row">
                                                <div class="col-sm-3 col-4 product__img">
                                                    <div class="thumb">
                                                        <!-- <img :src="[product.image ? $baseURL+ product.image  : 'http://dummy-images.com/abstract/dummy-300x300-FairyLights.jpg']"> -->
                                                        <img v-if="product.image" :src="[product.image]">
                                                        <img v-else src="../assets/img/default-noimg.png">
                                                    </div>
                                                </div>
                                                <div class="col-sm-9 col-8">
                                                    <div class="row">
                                                        <div class="d-sm-flex align-items-center mt-sm-2 col-12">
                                                            <div class="py-sm-3 px-3">
                                                                <h5 class="ui text big-lg medium-md small-sm tiny semibold text-truncate mb-lg-3 mb-0">{{product.name}}</h5>
                                                                <p class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0">{{ (product.netPrice != 0) ? currency + formatPrice(product.netPrice) : currency + formatPrice(product.price) }}  </p>
                                                                <p v-if="product.price != product.netPrice" class="ui text big-lg medium-md tiny-sm small light line-through m-0">{{currency}}{{formatPrice(product.price)}}</p>
                                                                <div v-if="product.sku" class="ui text big-lg medium-md small-sm tiny semibold text-truncate mt-lg-3">
                                                                    <span v-if="product.sku.sku1Name">{{product.sku.sku1Name}} : </span><span class="color red-2 mr-3"> &nbsp; {{product.sku.sku1Select}}</span> 
                                                                    <span v-if="product.sku.sku2Name">{{product.sku.sku2Name}} : </span><span class="color red-2"> &nbsp; {{product.sku.sku2Select}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="ml-auto text-right d-flex mt-lg-4">
                                                                <div class="ui text big-lg medium-md tiny-sm small light mr-3">
                                                                    {{product.amount}} ชิ้น
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-5 mt-md-0 mt-3">
                            <Summary :currency="currency" 
                                    :sumPrice="formatPrice(cartSummary.sumPrice)" 
                                    :deliveryFee="formatPrice(cartSummary.deliveryFee)" 
                                    :total="getTotal()"
                                     />
                            <div class="d-flex align-items-center mt-3">
                                <button v-if="$parent.logged == true && step == 1" 
                                    @click="toStep"
                                    class="ui button teal text large col-12">
                                    <span class="ui text large">{{$t('Next')}}</span>
                                </button>
                                <button v-if="$parent.logged == false" @click="toLogin" class="ui button teal text large col-12">
                                    <span class="ui text large">{{$t('SignIn')}} & {{$t('Register')}}</span>
                                </button>
                                <button v-if="$parent.logged == true && step == 2" 
                                    :disabled=" selectAddress == false" @click="createOrder" 
                                    class="ui button teal text large col-12">
                                    <span class="ui text large">{{$t('Next')}}</span>
                                </button>
                                <button  v-if="$parent.logged == true && step == 4" 
                                    @click="$router.push('/')" 
                                    class="ui button teal text large col-12">
                                    <span class="ui text large">{{$t('NowShop')}}</span>
                                </button>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="p-3 texteditor" v-html="paymentmethod"></div>
                    </div>
                </div>
            </section>
        </div>
        <div class="modal fade " id="modalAddress" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
              <div class="ui segment">
                  <div class="row m-0 w-100">
                      <div class="col-12 text-center p-0">
                            <span class="ui text big-lg medium-sm small semibold black">{{$t('AddAddress')}}</span>
                            <i class="close icon grey float-right" data-dismiss="modal" aria-label="Close"></i>
                      </div>
                  </div>
                  <form>
                      <hr>
                    <div class=" ui form">
                        <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                            <div class="col-12 col-lg-3 text-lg-right">
                                <label class="ui text medium-sm small color black">{{$t('Name')}}<span class=text-danger>*</span></label></div>
                            <div class="col-12 col-lg-8">
                                <input class="ui text input medium-sm small" type="text" placeholder v-model="showAddress.fullname"></div>
                        </div>
                        <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                            <div class="col-12 col-lg-3 text-lg-right">
                                <label class="ui text medium-sm small color black">{{$t('Address')}}<span class=text-danger>*</span></label></div>
                            <div class="col-12 col-lg-8">
                                <input class="ui text input medium-sm small" type="text" placeholder v-model="showAddress.address"></div>
                        </div>
                        <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                            <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('Street')}}<span class=text-danger>*</span></label></div>
                            <div class="col-12 col-lg-8"><input class="ui text input medium-sm small" type="text" placeholder v-model="showAddress.street"></div>
                        </div>
                        <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                            <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('Province')}}<span class=text-danger>*</span></label></div>
                            <div class="col-12 col-lg-8">
                                <select class="ui input text medium-sm small  custom-select col-12"
                                    @change="getAmphur()"
                                    v-model="showAddress.province_id">
                                    <option  :value="null" disabled>{{$t('SelectProvince')}}</option>
                                    <option v-for="province in provinces" 
                                        :value="province.id"
                                        :selected="province.id == showAddress.province_id">{{province.name_in_thai}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                            <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('Amphur')}}<span class=text-danger>*</span></label></div>
                            <div class="col-12 col-lg-8">
                                <select class="ui input text medium-sm small  custom-select col-12"
                                    @change="getDistrict()"
                                    v-model="showAddress.amphur_id">
                                    <option  :value="null" disabled>{{$t('SelectAmphur')}}</option>
                                    <option v-for="amphur in amphurs" 
                                        :value="amphur.id"
                                        :selected="amphur.id == showAddress.amphur_id">{{amphur.name_in_thai}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                            <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('District')}}<span class=text-danger>*</span></label></div>
                            <div class="col-12 col-lg-8">
                                <select class="ui input text medium-sm small ui  custom-select col-12"
                                    v-model="showAddress.district_id">
                                    <option  :value="null" disabled>{{$t('SelectDistrict')}}</option>
                                    <option v-for="district in districts" 
                                        :value="district.id"
                                        :selected="district.id == showAddress.district_id">{{district.name_in_thai}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                            <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('PostCode')}}<span class=text-danger>*</span></label></div>
                            <div class="col-12 col-lg-8"><input class="ui text input medium-sm small" type="text" placeholder v-model="showAddress.zipcode"></div>
                        </div>
                        <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                            <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black">{{$t('Mobile')}}<span class=text-danger>*</span></label></div>
                            <div class="col-12 col-lg-8"><input class="ui text input medium-sm small" type="text" placeholder v-model="showAddress.phone"></div>
                        </div>
                        <div class="row mt-lg-2 mt-3 mb-2 align-items-center">
                            <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small color black"></label></div>
                            <div class="col-12 col-lg-8">
                                <div class="row">
                                    <div class="col">
                                        <button @click.prevent="updateAddress" class="ui button theme text large col-12 py-2"><span class="ui text large">{{$t('Save')}}</span></button></div>
                                    <div class="col">
                                        <div @click="closePopup" class="ui button grey text large col-12 py-2"><span class="ui text large">{{$t('Cancel')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Category from '@/components/category/Category'
import CategoryMobile from '@/components/category/CategoryMobile'
import Summary from '@/components/cart/Summary'
import _ from "lodash";
import axios from "@/api/axios";

export default {
  name: 'cart',
  components: {
        Category,
        CategoryMobile,
        Summary,
    },
    data() {
        return {
            loading: false,
            cartValue: 0,
            cartSummary: {
                sumPrice : 0,
                deliveryFee: 0,
                total: 0
            },
            step: 1,
            currency: '',
            addressId: 0,
            shippingId: 0,
            boxAddress:{},
            address: [],
            showAddress : {
                id: null,
                fullname: '',
                address: '',
                street: '',
                province_id: null,
                amphur_id: null,
                district_id: null,
                zipcode: '',
                phone: ''
            },
            provinces:[],
            amphurs: [],
            districts:[],
            urlImg: null,
            shippingServices: [],
            selectAddress: false,
            shippingName: '',
            order: {},
            imageTranfer: null,
            productComplete: [],
            selectSkuId: 0,
            paymentmethod:"",
        }
  },
    computed: mapState(["cartProducts"]),
    created(){
        this.checkProduct()
        this.currency = this.$parent.currency
        this.getSumary()
        if(this.$parent.logged == true){
            
        }
    },
    mounted() {
        this.getAddress()
        axios.get(this.$baseURL + '/api/addresses')
        .then(response => {
            this.provinces = response.data
        })
    },
    methods: {
        /* Initially loading the cart products from local storage */
        ...mapMutations(["SET_CART_PRODUCTS", "EDIT_CART_LOCAL",'REMOVE_CART_LOCAL','CLEAR_CART']),
        checkProduct(){
            this.cartProducts.forEach(product => {
                this.$http.get('products/' + product.id)
                .then(res => {
                    let item = res.data.data 
                    let newProduct = product
                    newProduct.price = item.price
                    newProduct.quantity = item.quantity
                    newProduct.skus = null
                    if(item.skus.length > 0){
                        if(product.sku && product.sku.sku1Id != null){
                            let data = _.find(item.skus, {'sku1Id' : product.sku.sku1Id,'sku2Id' :product.sku.sku2Id});
                            if (data != undefined) {
                                newProduct.sku = data
                                newProduct.skus = item.skus
                                if(item.skuOptions[0]){
                                    newProduct.sku.sku1Name = item.skuOptions[0].name
                                   let sku = _.find(item.skuOptions[0].skus, {'id' : product.sku.sku1Id});
                                   if(sku){
                                        newProduct.sku.sku1Select = sku.name
                                   }
                                }
                                if(item.skuOptions[1]){
                                    newProduct.sku.sku2Name = item.skuOptions[1].name
                                   let sku = _.find(item.skuOptions[1].skus, {'id' : product.sku.sku2Id});
                                   if(sku){
                                        newProduct.sku.sku2Select = sku.name
                                   }
                                }
                                newProduct.quantity = data.quantity
                                newProduct.price = data.price
                                newProduct.netPrice = data.netPrice
                            }else{
                                newProduct.sku = null
                            }
                        }else{
                            newProduct.sku = null
                            newProduct.skus = item.skus
                        }
                    }else{
                        newProduct.sku = null
                        newProduct.price = item.price
                        newProduct.netPrice = item.netPrice
                    }
                    if(newProduct.quantity < newProduct.amount){
                        newProduct.amount = newProduct.quantity
                    }
                    this.EDIT_CART_LOCAL(newProduct)
                })
            });
            this.getSumary()
        },
        selectSku(itemId){
            let product = _.find(this.$store.getters.cartProducts, {'itemId' : itemId});
            if (product) {
                product.sku = this.selectSkuId
                product.price = this.selectSkuId.price
                product.netPrice = this.selectSkuId.netPrice
                this.EDIT_CART_LOCAL(product)
                this.getSumary()
            }
        },
        skuName(sku){
            let name = ""
            name = sku.sku1Name + " : " + sku.sku1Select
            if(sku.sku2Select != null){
                name += " , " + sku.sku2Name + " : " + sku.sku2Select
            }
            return name
        },
        formatPrice(value) {
            let price = Number(value)
            return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        getTotal(){
            let val = Number(this.cartSummary.total)
            val.toFixed(2)
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        getLocalProducts() {
            let products = JSON.parse(localStorage.getItem("was-cart"))
            if (products) {
                this.SET_CART_PRODUCTS(products);
                this.getSumary()
            }
        },
        getAddress(){
            this.$http.get('profile').then(response => {
                let res = response.data.data
                let address = res.getAddress
                this.address = address
            })
            .catch(error => {
                this.logged = false
                localStorage.removeItem("_auth");
                localStorage.removeItem("accountType");
            })
        },
        removeToCart(item) {
            let data = _.find(this.$store.getters.cartProducts, {'itemId' : item.itemId});
            if (data) {
                this.REMOVE_CART_LOCAL(item);
                this.getSumary()
            }
        },
        increment(item){
            let data = _.find(this.$store.getters.cartProducts, {'itemId' : item.itemId});
            if (data) {
                if(data.amount + 1 <= data.quantity ){
                    data.amount = data.amount + 1
                }else{
                    data.amount = data.quantity
                }
                this.EDIT_CART_LOCAL(data);
                this.getSumary()
            }
        },
        decrement(item){
            const data = _.find(this.$store.getters.cartProducts, {'itemId' : item.itemId});
            if (data) {
                if( data.amount > 1 ){
                    data.amount = data.amount - 1
                    this.EDIT_CART_LOCAL(data);
                    this.getSumary()
                }
            }
        },
        getSumary(){
            var sumPrice = 0
            var deliveryFee = 0
            this.cartProducts.forEach(Item => {
                if(Item.netPrice == 0){
                    Item.netPrice = Item.price
                }
                let sum = Number(Item.netPrice) * Number(Item.amount)
                sumPrice += sum
            })
            var cartSummary = {
                sumPrice : sumPrice,
                deliveryFee: deliveryFee,
                total: sumPrice + deliveryFee
            }
            this.cartSummary = cartSummary
        },
        toLogin(){
            this.$router.push('/login')
        },
        toStep(){
            switch (this.step) {
                case 1:
                    this.step = this.step + 1
                    break;
                case 2:
                    this.step = this.step + 1
                    break;
                default:
                    break;
            }
        },
        showModalAddress(id = null){
            this.showAddress.id = id
            $( function(){
                $('#modalAddress').modal('toggle')
            })
        },
        closePopup(){
            $('#modalAddress').modal('toggle')
        },
        getDistrict(){
            let id = this.showAddress.amphur_id
            if(id == null){return}
            axios.get(this.$baseURL + '/api/addresses/district/' + id)
            .then(response => {
                this.districts = response.data
                if(this.id == null){
                    this.showAddress.district_id = null
                }
            })
            .catch(error => console.log(error))
        },
        getAmphur(){
            let id = this.showAddress.province_id
            if(id == undefined){return}
            axios.get(this.$baseURL + '/api/addresses/amphur/' + id)
            .then(response => {
                this.amphurs = response.data
                this.districts = []
                if(this.id == null){
                    this.showAddress.amphur_id = null
                    this.showAddress.district_id = null
                }
                this.getDistrict()
            })
            .catch(error => console.log(error))
        },
        updateAddress(){
            let data = this.showAddress
            if(data.fullname == '' || data.fullname == null ){
                return
            }
            if(data.address == '' || data.address == null ){
                return
            }
            if(data.street == '' || data.street == null ){
                return
            }
            if(data.province_id == '' || data.province_id == null ){
                return
            }
            if(data.amphur_id == '' || data.amphur_id == null ){
                return
            }
            if(data.district_id == '' || data.district_id == null ){
                return
            }
            if(data.zipcode == '' || data.zipcode == null ){
                return
            }
            if(data.phone == '' || data.phone == null ){
                return
            }
            let url = ''
            if(data.id == null){
                url = 'address'
            }else{
                url = 'address/' + data.id
                data._method = 'PUT'
            }
            this.$http.post(url,data)
            .then(res => {
                this.getAddress()
                this.showModalAddress()
            })
            .catch(error => {
                if(!error.response){
                    return
                }
                let message = error.response.data.errors.message
                if(message != ''){
                    this.$parent.message.message = message
                    this.$parent.showMessage = !this.$parent.showMessage
                }
            })
        },
        onFileChange(e) {
            let file = e.target.files[0];
            if(file == undefined){return}
            this.imageTranfer = file
            this.urlImg = URL.createObjectURL(file);
        },
        getShippingPrice(){
            if(this.addressId == 0){
                return
            }
            this.shippingId = 0
            this.selectAddress = false
            this.loading = true
            let products = this.cartProducts
            products.map(product=> {product.skuId = (product.sku != null) ? product.sku.id : null })
            let data = {
                addressId: this.addressId,
                products: products
            }
            this.$http.post('get/price',data)
            .then(response => {
                let res = response.data.data
                this.shippingServices = res.shippings
                $(function () {
                    $("html,body").animate({scrollTop:$("h2").offset().top},"1000")
                })
            })
            .catch(error => {
                // location.reload()
            })
            .finally(() => this.loading = false)
        },
        createOrder(){
            console.log('createOrder')
            //api create order
            let data = {
                addressId: this.addressId,
                shippingFeeCheck: this.shippingFeeCheck,
                courierCode: this.shippingId,
                products : this.cartProducts
            }
            this.$http.post('orders',data)
            .then(response => {
                let res = response.data.data
                this.order = res
                let cartSummary = {
                    sumPrice : Number(this.order.price),
                    deliveryFee: Number(this.order.shippingFee),
                    total: Number(this.order.totalPrice)
                }
                this.cartSummary = cartSummary
                this.step = 3
            })
            .catch(error => {})
            .finally(() => this.loading = false)
        },
        tranferOrder(){
            this.loading = true
            console.log('tranferOrder')
            let formData = new FormData();
            formData.append('file', this.imageTranfer);
            formData.append('orderNo', this.order.orderNo);
            this.$http.post('orders/tranfer',formData,{headers: {'Content-Type': 'multipart/form-data'}})
            .then(response => {
                let res = response.data.data
                this.order = res
                let cartSummary = {
                    sumPrice : Number(this.order.price),
                    deliveryFee: Number(this.order.shippingFee),
                    total: Number(this.order.totalPrice)
                }
                this.cartSummary = cartSummary
                this.productComplete = this.cartProducts
                this.CLEAR_CART()
                this.step = 4
                $("html,body").animate({scrollTop:$("h2").offset().top},"1000")
            })
            .catch(error => {
                let message = 'เกิดข้อผิดพลาด ไม่สามารถทำรายการได้'
                this.$parent.message = {
                    message: message,
                    title: this.$t('OrderingProduct')
                }
                this.$parent.showMessage = !this.$parent.showMessage
                console.log(message)
            })
            .finally(() => this.loading = false)
        },
        getPaymentmethod(get){
            if(get==true){
                this.$http.get('paymentmethod')
                .then(response => {
                    this.paymentmethod = response.data.data
                })
                .catch(error => {
                this.paymentmethod = ""
                })
            }else{
                this.paymentmethod = ""
            }
        }
    },
    watch:{
        addressId(id){
            let data = _.find(this.address, {'id' : id});
            if (data) {
                this.boxAddress = data
                this.getShippingPrice()
            }else{
                this.addressId = null
            }
        },
        shippingId(id){
            if(id != 0 && this.addressId != 0){
                let data = _.find(this.shippingServices, {'courierCode' : id})
                if(data){
                    this.shippingName = data.name
                    this.shippingFeeCheck = data.shippingFeeCheck
                    this.cartSummary.deliveryFee = Number(data.price)
                    let total = Number(this.cartSummary.sumPrice) + Number(data.price)
                    this.cartSummary.total = total.toFixed(2)
                    this.selectAddress = true
                }
            }
        }
    },
    destroyed(){
        $(function () {
            $(function(){
            $(window).scrollTop(0);
            })
        })
    },
}
</script>
<style lang="scss">
    .pointer{
        cursor: pointer;
    }
    .ui.teal.buttons .button:active, .ui.teal.button:active {
        background-color: #40D3C1;
    }
    .ui.teal.buttons .button:focus, .ui.teal.button:focus{
        background-color: #40D3C1;
    }
    .custom-tabs.ui.buttons.nav.nav-tabs{
        flex-wrap: unset;
        border: none;
        a{
            min-width: 206px;
        }
    }
    .box-upload{
        background-color: rgb(69,69,69);
        width: 100%;
        min-height: 400px;
        padding: .7rem;
        position: relative;
        input{
            position: absolute;
            opacity: 0;
        }
    }
    .box-upload::before{
            top: 1.5%;
            content: "";
            position: absolute;
            border: .1rem;
            border-color: darkgray;
            border-style: dashed;
            height: 97%;
            width: 97%;
        }
    .text-center{
        text-align: center;
    }
</style>